import { combineReducers } from "redux";

// Layout
import Layout from "./layout/reducer";

//login
import login from "./auth/login/reducer";

import maintenance from "./Maintenance/maintenanceReducer";

import auth from "./Authentication/authReducer";
import specialAccessSlice from "./Authentication/specialAccessSlice";

import accounting from "./Accounting/accountingReducer";

import forgetPassword from "./auth/forgetpwd/reducer";

import prices from "./Prices/pricesReducer";

import stores from "./Stores/storesReducer";

import customers from "./Customers/customersReducer";

import products from "./Products/productsReducer";

import offers from "./Offers/offersReducer";

import general from "./General/generalReducer";

import company from "./Company/companyReducer";

import inventory from "./Inventory/inventoryReducer";

import pos from "./POS/posReducer";

import doc from "./Doc/docReducer";

import humanResources from "./HumanResources/humanResourcesReducer";

const rootReducer = combineReducers({
  // public
  Layout,
  login,
  maintenance,
  auth,
  specialAccess: specialAccessSlice,
  accounting,
  forgetPassword,
  prices,
  stores,
  customers,
  products,
  offers,
  general,
  company,
  inventory,
  pos,
  doc,
  humanResources,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof rootReducer;
